import ThemeOverrideProps from 'ThemeOverrideProps';
import {StyleSheet} from 'react-native';
const {fontExtraBold, fontRegular, fontSemiBold, fontBold, fontSizeH3} =
  ThemeOverrideProps.sheetStyles;

export const stylesFn = (containerStyleOverride?: object) =>
  StyleSheet.create({
    container: {
      marginTop: -24,
      backgroundColor: '#E9F4FE',
      height: 96,
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 24,
      ...containerStyleOverride,
    },

    contentContainer: {
      bottom: 0,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 24,
      gap: 8,
    },
    contentText: {
      color: '#2D2D2D',
      ...fontSemiBold,
      fontSize: 13,
      lineHeight: 20,
      letterSpacing: -0.01,
      textAlign: 'left',
      textTransform: 'capitalize',
      maxWidth: '70%',
    },
    withdrawAmountText: {
      ...fontBold,
      ...fontSizeH3,
      color: 'rgb(98, 180, 57)',
      lineHeight: 20,
      letterSpacing: -0.01,
    },
    headerText: {
      color: '#333',
      ...fontExtraBold,
      fontSize: 16,
      textTransform: 'capitalize',
    },
    headerContainerStyleOverride: {
      paddingTop: 0,
      paddingBottom: 10,
      height: 37,
      shadowColor: 'rgba(0, 0, 0, 0.5)',
      shadowOffset: {
        width: 0,
        height: -4,
      },
      shadowOpacity: 0.25,
      shadowRadius: 1.84,
      elevation: 5,
    },
    viewDetailsText: {
      color: '#367BCE',
      fontSize: 14,
      ...fontExtraBold,
    },
    viewDetailsButton: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 10,
    },
    chevronIcon: {
      width: 30,
      height: 30,
    },

    // Confirmation Modal
    confirmationContainer: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    confirmationTitle: {
      color: '#070707',
      fontSize: 20,
      lineHeight: 24,
      textAlign: 'center',
      letterSpacing: -0.03,
      ...fontExtraBold,
      opacity: 0.9,
    },
    confirmationAmountContainer: {
      marginTop: 16,
    },
    confirmationAmountText: {
      textAlign: 'center',
      color: '#070707',
      fontSize: 16,
      lineHeight: 18,
      letterSpacing: -0.01,
      ...fontRegular,
    },
    confirmationAmountTextCash: {
      ...fontBold,
      color: 'rgb(98, 180, 57)',
    },
    confirmationWarningText: {
      textAlign: 'center',
      color: '#FF0000',
      fontSize: 13,
      lineHeight: 18,
      letterSpacing: -0.01,
      ...fontRegular,
      marginTop: 16,
    },
    confirmButton: {
      marginTop: 53,
      maxHeight: 43,
      backgroundColor: '#367BCE',
      alignSelf: 'stretch',
      flex: 1,
      borderRadius: 58,
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 19,
    },

    confirmButtonDisabled: {
      opacity: 0.5,
    },
    confirmButtonText: {
      color: '#FFFFFF',
      fontSize: 16,
      ...fontExtraBold,
      textAlign: 'center',
      textTransform: 'uppercase',
    },
  });
